import { styled } from 'styled-components'

export const TitleConfig = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
`
export const WrapperInput = styled.div`
  margin: 20px 0;
`

export const WrapperButton = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
`
